import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    templateUrl: './watch-now.component.html',
    styleUrls: ['./watch-now.component.less'],
    encapsulation: ViewEncapsulation.None,
    selector: 'watch-now',
})
export class WatchNowComponent extends AppComponentBase {

    isModalOpen = false;
    youtubeUrl: SafeResourceUrl;

    constructor(injector: Injector, private sanitizer: DomSanitizer) {
        super(injector);
        this.youtubeUrl = '';
    }

    onWatchNow(): void {
        this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/QiDV6ZVFrgQ?autoplay=1');
        this.isModalOpen = true;
    }

    openModal() {
        this.isModalOpen = true;
        document.body.style.overflow = 'hidden';
    }
    closeModal() {
        this.isModalOpen = false;
        document.body.style.overflow = '';
    }
}
